var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsDownloadallSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 4.762 4.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.988 2.15l1.256 1.386a.187.187 0 00.262.006l.006-.006L3.774 2.15a.178.178 0 00.012-.25.178.178 0 00-.25-.012l-.024.024-.952 1.048V.179A.175.175 0 002.38 0a.175.175 0 00-.178.179v2.774L1.256 1.91a.18.18 0 00-.25-.036.18.18 0 00-.036.25.082.082 0 00.018.024zM4.584 4.405H.179A.175.175 0 000 4.584c0 .101.077.179.179.179h4.405a.175.175 0 00.179-.18.175.175 0 00-.18-.178z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsDownloadallSmallIcon);
export default __webpack_public_path__ + "static/media/documents-downloadall-small-icon.e45dd6531b38fc70a989d90e9a9648e5.svg";
export { ForwardRef as ReactComponent };